
import { createContext, useContext, useState } from "react";

const DashboardFiltersContext = createContext(null);

export function DashboardFiltersProvider({ children }) {
  const [appliedFilters, setAppliedFilters] = useState(null);

  return (
    <DashboardFiltersContext.Provider value={{ appliedFilters, setAppliedFilters }}>
      {children}
    </DashboardFiltersContext.Provider>
  );
}

export function useDashboardFilters() {
  return useContext(DashboardFiltersContext);
}
